import { storeStructure } from '../store/reducers';
import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import viewAppCategories from './viewRelatedAppCategoriesWhiteLabel';
import viewRelatedAppPackages from './viewRelatedAppPackages';
import tableComposeExperienceUrls from './tableComposeExperienceUrls';
import tableComposeExperienceLiveUrls from './tableComposeExperienceLiveUrls';
import { IconType } from '../components/atoms/icon/icon';
import viewRelatedAppTags from './viewRelatedAppTags';

const defaultActivationDate = new Date();
const defaultExpirationDate = new Date();
defaultExpirationDate.setFullYear(defaultExpirationDate.getFullYear() + 10);
export default {
  storeNode: storeStructure.VideoContentVideos,
  title: 'General values',
  fields: [
    {
      attributeName: 'name',
      helpText: 'Title of the video.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Name',
      placeholder: 'Video name...',
    },
    {
      attributeName: 'isLive',
      helpText: 'Specifies if the content is a live stream or VOD.',
      label: 'Is Live',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'composeExperienceObj',
      type: FormInputTypes.TEXT_INPUT.OBJECT,
      helpText: 'URL of the video dash manifest. You can search for a processed video by the VoD backend in the next button.',
      label: 'Media URL',
      visibleWhen:{"field":"isLive","value":false},
      placeholder: 'Video Url...',
      mainField:"url",
      fromConfigTable: tableComposeExperienceUrls,
      popupSize:'xl',
      fieldsToUpdate:["duration","content_type"]
    },
    {
      attributeName: 'composeExperienceObj',
      type: FormInputTypes.TEXT_INPUT.OBJECT,
      helpText: 'URL of the video dash manifest. You can search for a processed video by the VoD backend in the next button.',
      label: 'Media URL Live',
      visibleWhen:{"field":"isLive","value":true},
      placeholder: 'Video Url...',
      mainField:"url",
      fromConfigTable: tableComposeExperienceLiveUrls,
      popupSize:'xl',
      fieldsToUpdate:["duration","content_type"]
    },
    {
      attributeName: 'liveLink',
      label:'Live link',
      type: FormInputTypes.LINK,
      icon: IconType.VIDEO,
      width: '4rem',
      target:'_self',
      iconSize:'2x',
      iconColor:'#17a2b8',
      helpText: 'Link to the corresponding live event.',
      // visibleWhen:[{"field":"isLive","value":true},{"field":"id","value":"not-null"}],
      visibleWhen:[{"field":"isLive","value":true}]
    },
    {
      attributeName: 'content_type',
      label: 'Content Type',
      default: 'Single-View',
      type: FormInputTypes.SELECT,
      helpText: 'Choose one type of content.',
      options: [
        { name: '(Unknown)', value: '-1' },
        { name: 'Single view', value: 'Single-View' },
        { name: 'Multi view', value: 'Multi-View' },
        { name: 'Immersive', value: 'Immersive' },
        { name: 'Immersive + Multi-View', value: 'Immersive-Multi-View' },
      ],
      disabled:true,
      // visibleWhen:[{"field":"id",value:"not-null"}]
    },
    {
      attributeName: 'duration',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Duration',
      visibleWhen:{"field":"isLive","value":false},
      placeholder: 'Video duration...',
      helpText: 'Duration of the video in the format mm:ss.',
      disabled:true,
      // visibleWhen:[{"field":"id",value:"not-null"}]
    },   
    {
      attributeName:"sep1",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'visibility',
      label: 'Visibility',
      helpText: 'Visibility of the video in the panel its listed.',
      default: 'enabled',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Enabled', value: 'enabled' },
        { name: 'Disabled', value: 'disabled' },
        { name: 'Hidden', value: 'hidden' },
      ],
    },
    {
      attributeName: 'activationEpoch',
      label: 'Activation Time',
      helpText: 'Date of the activation event for this video.',
      type: FormInputTypes.DATE_TIME,
      default: defaultActivationDate.getTime(),
      sendAlwaysAtCreate: true,
    },
    {
      attributeName: 'startEpoch',
      visibleWhen:{"field":"isLive","value":true},
      label: 'Starting Time',
      helpText: 'Date of the starting event countdown.',
      type: FormInputTypes.DATE_TIME,
    },
    {
      attributeName: 'expirationEpoch',
      label: 'Expiration Time',
      helpText: 'Date of the expiration event for this video.',
      type: FormInputTypes.DATE_TIME,
      default: defaultExpirationDate.getTime(),
      sendAlwaysAtCreate: true,
    },
    {
      attributeName: 'isLiveContinuous',
      visibleWhen:{"field":"isLive","value":true},
      label: 'Remove Progress Indicator',
      helpText: 'Selecting this field hides the current progress indicator from the player bar, making it invisible to the end user. This option should remain checked for 24/7 live streams.',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'liveStatus',
      label: 'Stream Status2',
      helpText: 'Check the status of a live event (STOPPED, ONGOING, ENDED).',
      default: 'offline',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Offline', value: 'offline' },
        { name: 'Live Ongoing', value: 'ongoing' },
        { name: 'Live Ended', value: 'ended' },
      ],
      disabled:true,
      visibleWhen:{"field":"isLive","value":true},
     
    },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'appCategories',
      label: 'Categories',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      configFile: viewAppCategories,
      default: [],
      helpText: 'Video categories joined.',
    },
    {
      attributeName: 'appTags',
      label: 'Tags',
      type: FormInputTypes.RELATIONSHIPFILTER,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedAppTags,
      default: [],
      helpText: 'Video tags joined.',
    },
    {
      attributeName: 'appPackages',
      label: 'V.T. Providers',
      type: FormInputTypes.RELATIONSHIP,
      canEdit: true,
      canCreate: true,
      configFile: viewRelatedAppPackages,
      default: [],
      helpText: 'This content can be blocked by a virtual ticket provider, select one or multiple providers to block it.',
    },
    {
      attributeName:"sep3",
      type:FormInputTypes.SEPARATOR
    },
        {
      attributeName: 'geometry',
      label: 'Geometry',
      helpText: 'Signaling version of the video.',
      default: 'v2',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Autodetect', value: 'v2' },
        { name: 'Equirectangular', value: 'equirectangular' },
        { name: 'Equidome', value: 'equidome' },
        { name: 'Flat', value: 'flat' },
      ],
    },
    {
      attributeName: 'type',
      label: 'Type',
      default: 'mono',
      type: FormInputTypes.SELECT,
      helpText: 'Whether the video is mono or stereo.',
      options: [
        { name: 'Mono', value: 'mono' },
        { name: 'Stereo', value: 'stereo' },
        { name: 'Stereo LR', value: 'stereolr' },
      ],
      visibleWhen:[{"field":"geometry","notValue":"v2"}]

    },
    {
      attributeName: 'isAudioRecordingAllowed',
      helpText: 'Specifies if the content allow audio feedback.',
      label: 'Allow Audio feedback ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isSlowMotionAllowed',
      helpText: 'Specifies if the content allow slow motion.',
      label: 'Allow Slow motion ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName: 'isTimeShiftingAllowed',
      helpText: 'Specifies if the content allow slow motion.',
      label: 'Allow Timeshift ',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'backgroundFlat',
      type: FormInputTypes.BACKGROUND,
      label: 'Background Flat',
      helpText: 'Background to use in the flat video geometries.',
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'background180',
      type: FormInputTypes.BACKGROUND,
      label: 'Background 180',
      helpText: 'Background to use in the 180 video geometries.',
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'graphicsManifestURL',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Graphics Manifest',
      helpText: 'URL to the graphics manifest for the video. To learn more about graphics manifest, please refer to the “Graphics Manifest” documentation.',
      placeholder: 'Video graphics manifest...',
      fileType: ['.json'],
    },
    {
      attributeName:"sep2",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'poster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Thumbnail Poster (158x120)',
      helpText: 'Any valid url to a PNG poster image file to use inside the app main panel.',     
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'posterTablet',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Thumbnail Poster Tablet (320x242)',
      helpText: 'Any valid url to a PNG poster image file to use inside the app main panel.',      
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName:"sep3",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'largePoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Header Poster (588x380)',
      helpText: 'Any valid url to a PNG poster image file to use inside a side panel.',    
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'largePosterPortrait',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Header Poster Tablet Portrait (1176x760)',
      helpText: 'Any valid url to a PNG poster image file to use inside a side panel.',  
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'largePosterLandscape',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Header Poster Tablet Landscape (1432x760)',
      helpText: 'Any valid url to a PNG poster image file to use inside a side panel.',      
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName:"sep4",
      type:FormInputTypes.SEPARATOR
    },
    {
      attributeName: 'descriptionPoster',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Description Poster (360x250)',
      helpText: 'URL to the poster image file that will be show in the description panel.',
      placeholder: 'Video description poster URL...',
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'descriptionPosterLargePortrait',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Description Poster Large Portrait (720x540)',
      helpText: 'URL to the poster image file that will be show in the description panel.',
      placeholder: 'Video description poster URL...',
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'descriptionPosterLargeLandscape',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Description Poster Large Landscape (926x328)',
      helpText: 'URL to the poster image file that will be show in the description panel.',
      placeholder: 'Video description poster URL...',
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
    },
    {
      attributeName: 'description',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'Description',
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
    },
    {
      attributeName: 'producers',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Producers',
      placeholder: 'Video producers...',
      helpText: 'Producers of the video.',
    },
    {
      attributeName: 'isHighQuality',
      label: 'Is High Quality',
      helpText: 'Whether the video is in 8K quality.',
      default: false,
      type: FormInputTypes.CHECKBOX,
    },
  ],
};
